import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { S_PageStyle } from 'pages/page/PageStyle';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const FjellseterPage = (props: Props): JSX.Element => {
    return (
        <S_FjellseterPage className={props.className}>
            <CustomMapPage
                mapId={'ec528b6b-1244-47b7-b24f-ab01dba34b82'}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/68f29630-98be-4336-8c71-5e755699c3d3.png',
                    logoText: 'Fjellseterløpet',
                    logoSubtext: '6.5. 2023',
                    link: 'https://cutt.ly/b57utBG',
                    linkText: 'Buy tickets'
                }}
                mapChildren={<></>}
            />
            <S_Area>
                <a target="_blank" href="https://cutt.ly/m57uoPE" rel="noreferrer">
                    <S_Button>BUY TICKETS</S_Button>
                </a>
            </S_Area>
        </S_FjellseterPage>
    );
};

const S_FjellseterPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;

const S_Area = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    pointer-events: none;
    display: flex;
    justify-content: center;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);
    padding: 0 0 20px 0;
`;

const S_Button = styled.div`
    pointer-events: all;
    background: #678dd2;
    border: 3px solid #000000;
    box-shadow: 0px 5px 0px #000000;
    border-radius: 15px;
    padding: 15px 25px;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
    text-shadow: 2px 2px 0px #000000;
    cursor: pointer;
    &:hover {
        background: #7298df;
    }
`;
